var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
    fill: "#FFAD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 18.6667H21.3334C20.6262 18.6667 19.9479 18.9477 19.4478 19.4478C18.9477 19.9479 18.6667 20.6262 18.6667 21.3334C18.6667 22.0407 18.9477 22.7189 19.4478 23.219C19.9479 23.7191 20.6262 24.0001 21.3334 24.0001H26.6667C27.374 24.0001 28.0523 24.281 28.5524 24.7811C29.0525 25.2812 29.3334 25.9595 29.3334 26.6667C29.3334 27.374 29.0525 28.0523 28.5524 28.5524C28.0523 29.0525 27.374 29.3334 26.6667 29.3334H18.6667M24.0001 32.0001V16.0001M37.3334 24.0001C37.3334 31.3639 31.3639 37.3334 24.0001 37.3334C16.6363 37.3334 10.6667 31.3639 10.6667 24.0001C10.6667 16.6363 16.6363 10.6667 24.0001 10.6667C31.3639 10.6667 37.3334 16.6363 37.3334 24.0001Z",
    stroke: "#004AAD",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.fdb9c6f13948ba7715f0d9ed9121d72b.svg";
export { ForwardRef as ReactComponent };